// extracted by css-extract-rspack-plugin
var _1 = "ucLpf";
export { _1 as "noAccessLabelDarkMode" }
